const ABOUTVPP = 'about-vpp'
const EXPLOREUSECASES = 'explore-usecases'

export {
  ABOUTVPP,
  EXPLOREUSECASES
}